/**
 * MSAL Configuration for Microsoft Entra (Azure AD) Authentication
 *
 * Required environment variables:
 * - REACT_APP_MICROSOFT_CLIENT_ID: Azure App Registration Client ID
 * - REACT_APP_MICROSOFT_TENANT_ID: nectr.com.au Tenant ID
 */

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '',
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANT_ID || 'common'}`,
        redirectUri: window.location.origin + '/entra-auth',
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
};
